import * as SensorPackagesConstants from "../constants/SensorPackages";

const initialState = {
  collection: [],
  pagination: {
    total: 0, perPage: 10, totalPages: 0, page: 0
  },
  sorting: {
    sort: 'asc', order: 'id', query: ''
  },
  isFetching: false
};

export function sensorPackages(state = initialState, action) {
  switch (action.type) {
    case SensorPackagesConstants.FETCH_SENSOR_PACKAGES_STARTED:
      return {...state, isFetching: true, collection: initialState.collection};
    case SensorPackagesConstants.FETCH_SENSOR_PACKAGES_COMPLETED:
      return {
        ...state, collection: action.content, pagination: action.pagination, sorting: action.sorting, isFetching: false
      };
    case SensorPackagesConstants.FETCH_SENSOR_PACKAGES_FAILED: {
      return {...state, isFetching: false};
    }
    default:
      return state;
  }
}
